export default __webpack_public_path__ + "static/media/timeline_header_logo.6744119b.png";